import { mixins, tokens } from 'src/design-system';

export const SEQuoteExchangeRatesStyles = () => ({
  // Mirrors the Additional Charges `exchangeRatesFooter` so both exchange-rate footers look the same.
  exchangeRatesFooter: {
    ...mixins.typography.caption,
    color: tokens.colors.textTertiary,
    marginTop: tokens.spacing.md,
  },
});
